<template>
  <div class="slides">
    <div v-for="i in getMaxPage()" :key="i" :id="'slide-' + i">
      <div class="plate">
        <img :src="base" alt="" />
      </div>
      <div id="seal1" v-if="sealsList.length >= (i - 1) * 3 + 1">
        <img :src="sealsList[(i - 1) * 3].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 3].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 3].text_color
          }"
        >
          {{ sealsList[(i - 1) * 3].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 3].get_at) }}
        </p>
      </div>
      <div id="seal1" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal2" v-if="sealsList.length >= (i - 1) * 3 + 2">
        <img :src="sealsList[(i - 1) * 3 + 1].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 3 + 1].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 3 + 1].text_color
          }"
        >
          {{ sealsList[(i - 1) * 3 + 1].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 3 + 1].get_at) }}
        </p>
      </div>
      <div id="seal2" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal3" v-if="sealsList.length >= (i - 1) * 3 + 3">
        <img :src="sealsList[(i - 1) * 3 + 2].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 3 + 2].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 3 + 2].text_color
          }"
        >
          {{ sealsList[(i - 1) * 3 + 2].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 3 + 2].get_at) }}
        </p>
      </div>
      <div id="seal3" v-else-if="i === 1">
        <img src="@/assets/img/seal/no_seal3end.png" alt="" />
      </div>
      <div id="seal3" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
    </div>
    <!---->
  </div>
</template>

<script>
export default {
  name: 'SealPlate3',
  props: ['base', 'seals', 'sealsList'],
  data: function() {
    return {
      isAndroid: false
    }
  },
  mounted: function() {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
  },
  async created() {},
  methods: {
    changeList: function(isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    },
    getExpiredDate(str) {
      const array = str.split('T')
      const date = array[0].split('-').join('.')
      return `${date}`
    },
    getMaxPage() {
      return ((this.seals.length / 3) | 0) + 1
    }
  }
}
</script>

<style scoped lang="scss">
.slides {
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-snap-type: x;
  //scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.scroll-snap-container::-webkit-scrollbar {
  display: none !important;
  height: 0;
  width: 0;
  background-color: transparent;
}
.slides > div {
  scroll-snap-align: start;
  flex-shrink: 0;
  position: relative;
  display: flex;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 3s;
}

.plate {
  margin-top: 21vw;
  position: relative;
  width: 94vw;
  height: 102vw;
}

#seal1 {
  margin-top: 31vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal1 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal2 {
  margin-top: 54vw;
  margin-left: 52vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal2 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal3 {
  margin-top: 77vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal3 img {
  width: 100%;
  height: auto;
  display: block;
}

.plate img {
  width: 100%;
  height: auto;
  display: block;
}

.t1 {
  position: absolute;
  font-size: 3.3vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 1vw;
  margin: 0;
}

.t1.is_android {
  top: 1.5vw;
}

.stroke {
  position: absolute;
  color: red;
  font-size: 3.3vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 1vw;
  margin: 0;
  -webkit-text-stroke: 3px white;
  text-stroke: 3px white;
}

.stroke.is_android {
  top: 1.5vw;
}

.t2 {
  position: absolute;
  color: white;
  font-size: 2.3vw;
  text-align: center;
  width: 100%;
  top: 31.5vw;
}

.t2.is_android {
  top: 32vw;
}
</style>
